import gql from 'graphql-tag';

export default gql`
mutation UserDecline(
        $uuid: String!
      ) {
    userDecline(uuid: $uuid) {
      __typename
    }
}
`;
